import { useMutation } from "@tanstack/react-query";
import { useToastActions } from "@rosette/web_components/feedback/toast/ToastContext.js";
import { addEarnedAchievementToasts } from "@/utils/achievements/addEarnedAchievementToasts.js";
import { requestAchievement } from "@/app/(api)/api/requestAchievement/requestAchievement.js";
import type { AchievementType } from "@rosette/ts/src/business/achievement/AchievementType.js";
import { featureFlags } from "@rosette/ts/src/business/featureFlags.js";
import { useAchievementResources } from "@/components/achievements/useAchievementResources.js";
import { useOptionalUser } from "@/components/env/EnvContext.js";


export function useGrantAchievementMutation(achievementType: AchievementType) {
    const { addToast } = useToastActions();
    const achievementResources = useAchievementResources();
    const user = useOptionalUser();

    return useMutation({
        mutationFn: async () => {
            // The endpoint answers 401 unless the account is complete, and callers
            // re-check this mutation on every game event, so a request that
            // cannot succeed would be re-sent for the rest of the game.
            if (!featureFlags.achievementsEnabled || user === null)
                return { earnedAchievements: [] };

            return await requestAchievement(achievementType);
        },
        onSuccess: (response) => {
            addEarnedAchievementToasts(response.earnedAchievements, addToast, achievementResources);
        },
    });
}
